import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
const projects = [{
  id: 1,
  title: "Cannabis Cloud",
  category: "Enterprise SaaS",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/project_cannabis_cloud.png",
  summary: "A specialized cloud infrastructure designed for the regulated cannabis industry, ensuring compliance and operational scale.",
  link: "/HoldingsPage"
}, {
  id: 2,
  title: "MilleMaster",
  category: "Smart Contracting",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/project_millemaster.png",
  summary: "Advanced legal-tech automation platform for managing large-scale enterprise agreements with smart-contract precision.",
  link: "/HoldingsPage"
}, {
  id: 3,
  title: "Crypto Pay Wallet",
  category: "Fintech Infrastructure",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/project_crypto_pay.png",
  summary: "A high-security digital asset gateway providing seamless payment processing and asset management for global commerce.",
  link: "/HoldingsPage"
}];
export default function RecentMasterpieces() {
  return <section data-section-id="25852" id="the-venture-ecosystem" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-border/40 pb-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-bold tracking-tighter uppercase font-default mb-4">
              The Venture <span className="text-primary">Ecosystem</span>
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-xl font-default">
              Strategic holdings and digital infrastructure built for scalable ownership in the next era of technology.
            </p>
          </div>
          <div className="hidden md:block">
            <Button variant="outline" className="rounded-none border-primary/50 hover:bg-primary/10 hover:text-primary hover:border-primary transition-colors font-default" asChild>
              <Link to="#">
                View All Holdings <ArrowUpRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="group relative w-full bg-card border border-border/50 overflow-hidden rounded-sm transition-transform duration-500 hover:scale-[1.02] hover:shadow-[0_0_30px_-10px_rgba(var(--primary),0.3)]">
              <AspectRatio ratio={16 / 9} className="bg-muted">
                {}
                <div className="absolute inset-0 overflow-hidden">
                  <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-[0.5]" />
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500" />
                </div>

                {}
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  {}
                  <div className="absolute top-6 left-6 right-6 z-10 mix-blend-overlay opacity-30 pointer-events-none select-none">
                     <span className="text-6xl md:text-7xl font-black tracking-tighter text-transparent stroke-text outline-text truncate block w-full font-default">
                       {`0${i + 1}`}
                     </span>
                  </div>

                  <div className="relative z-20 transform transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                    <div className="mb-2">
                      <span className="inline-block py-1 px-2 bg-primary/10 text-primary text-xs font-mono uppercase tracking-widest border border-primary/20 backdrop-blur-sm">
                        {project.category}
                      </span>
                    </div>
                    
                    <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-3 font-default tracking-tight group-hover:text-primary transition-colors duration-300">
                      {project.title}
                    </h3>

                    {}
                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-out">
                      <div className="overflow-hidden">
                        <p className="text-muted-foreground text-sm md:text-base mb-6 line-clamp-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 font-default">
                          {project.summary}
                        </p>
                        <Button className="w-full md:w-auto rounded-none bg-primary text-primary-foreground hover:bg-primary/90 transition-colors font-default" asChild>
                          <Link to={project.link}>
                            View Asset
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                
                {}
                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary/0 group-hover:border-primary/100 transition-colors duration-500" />
                <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary/0 group-hover:border-primary/100 transition-colors duration-500" />
                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary/0 group-hover:border-primary/100 transition-colors duration-500" />
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary/0 group-hover:border-primary/100 transition-colors duration-500" />
              </AspectRatio>
            </div>)}
        </div>

        <div className="mt-12 md:hidden text-center">
          <Button variant="outline" className="w-full rounded-none border-primary/50 text-primary font-default" asChild>
            <Link to="#">
              View All Holdings <ArrowUpRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>

      <style>{`
        .stroke-text {
          -webkit-text-stroke: 1px rgba(255, 255, 255, 0.15);
        }
      `}</style>
    </section>;
}